/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import LoginForm from './LoginForm';
import { WithLocalize, useLocalization } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';
import { Container, Row, Col } from 'reactstrap';
import './style.scss';
import Helmet from 'react-helmet';
import favicon from './img/favicon.ico';

const Login = ({ location, translate }) => {
  const { changeDefaultLocale } = useLocalization();
  useEffect(() => {
    changeDefaultLocale('es');
    document.title = '::. Login .::';
    document.body.style.backgroundColor = '#fafafa';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <Container fluid={true} className="bonda-body">
      <Helmet>
          <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>
          <Row>
            <Col>
              {
                _validateParams()
                  ? <LoginForm
                    api={api}
                    location={location}
                  />
                  : <RequestLoginErrorMessage
                    onlyMessage={true}
                    message={translate('RequestLoginErrorMessage')}
                  />
              }
            </Col>
          </Row>
    </Container>
  );
}

export default WithLocalize(Login);
